import { Chat } from "@launch10/use-langgraph-stream";
import { CreditGate } from "@components/shared/chat/input/CreditGate";
import { ArrowRight, Paperclip, Square } from "lucide-react";

/**
 * Website chat input using Chat compound components.
 *
 * Uses context-aware components that automatically bind to the composer,
 * handle streaming state, and manage attachments. Submit behavior and
 * disabled state are configured at Chat.Root level via isInputDisabled.
 *
 * Matches the same pattern as AdsChatInput for consistency.
 */
export default function WebsiteChatInput() {
  return (
    <div className="flex flex-col gap-1 w-full">
      <CreditGate>
        <Chat.Input.DropZone
          className="relative bg-white border border-neutral-300 rounded-2xl p-3 flex flex-col min-h-[80px]"
          data-testid="website-chat-dropzone"
        >
          <Chat.Input.AttachmentList className="flex flex-wrap gap-2 mb-2" />

          <Chat.Input.Textarea
            placeholder="Ask Houston anything, or drag an image in…"
            className="flex-1 text-xs min-h-[40px]"
            data-testid="website-chat-input"
          />

          <div className="flex items-center justify-between mt-auto pt-2">
            <Chat.Input.FileButton
              className="text-base-500 p-1 hover:bg-neutral-100 rounded"
              >
              <Paperclip className="size-4" />
            </Chat.Input.FileButton>

            <Chat.Input.SubmitButton
              stopIcon={<Square className="size-3" fill="currentColor" />}
              className="rounded-xl bg-primary-500 text-white hover:bg-primary-600 size-9 flex items-center justify-center"
              data-testid="website-chat-submit"
              >
              <ArrowRight className="size-4" />
            </Chat.Input.SubmitButton>
          </div>
        </Chat.Input.DropZone>
      </CreditGate>
    </div>
  );
}
